(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bandsintown-widget"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bitWidgetScriptLoaded) return;
    window.__bitWidgetScriptLoaded = true;
    var script = document.createElement('script');
    script.src = 'https://widget.bandsintown.com/main.min.js';
    script.async = true;
    document.body.appendChild(script);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-collage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ---- Justified layout (Flickr/Wix-style: rows scaled so they fill the
    // container edge-to-edge, using each photo's real aspect ratio so nothing
    // gets cropped). Runs on load and on resize (debounced). ----
    function layoutJustified(grid) {
      var items = Array.prototype.slice.call(grid.querySelectorAll('[data-photo-collage-trigger]'));
      if (!items.length) return;

      var containerWidth = grid.clientWidth;
      if (!containerWidth) return;

      var gap = parseFloat(grid.getAttribute('data-gap')) || 8;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      var perRow = parseInt(
        grid.getAttribute(isMobile ? 'data-per-row-mobile' : 'data-per-row-desktop'),
        10
      ) || (isMobile ? 2 : 5);

      var ratios = items.map(function (el) {
        return parseFloat(el.getAttribute('data-ratio')) || 1.5;
      });
      var avgRatio = ratios.reduce(function (sum, r) { return sum + r; }, 0) / ratios.length;
      var targetHeight = (containerWidth - (perRow - 1) * gap) / (perRow * avgRatio);
      targetHeight = Math.max(80, Math.min(targetHeight, 500));

      var row = [];
      var rowWidth = 0;

      function commitRow(isLast) {
        if (!row.length) return;
        var totalGap = gap * (row.length - 1);
        var naturalRowWidth = rowWidth - totalGap;
        var availableWidth = containerWidth - totalGap;
        var scale = availableWidth / naturalRowWidth;

        // Don't blow up a sparse last row (e.g. 1-2 photos) to an enormous height.
        if (isLast && scale > 1.35) {
          scale = 1;
        }

        var rowHeight = targetHeight * scale;
        row.forEach(function (el) {
          var ratio = parseFloat(el.getAttribute('data-ratio')) || 1.5;
          el.style.height = rowHeight + 'px';
          el.style.width = (rowHeight * ratio) + 'px';
          el.style.flex = '0 0 auto';
        });
        row = [];
        rowWidth = 0;
      }

      items.forEach(function (el) {
        var ratio = parseFloat(el.getAttribute('data-ratio')) || 1.5;
        var naturalWidth = targetHeight * ratio;
        var addedWidth = naturalWidth + (row.length ? gap : 0);

        if (rowWidth + addedWidth > containerWidth && row.length > 0) {
          commitRow(false);
        }

        row.push(el);
        rowWidth += naturalWidth + (row.length > 1 ? gap : 0);
      });

      commitRow(true);
      grid.setAttribute('data-collage-ready', 'true');
    }

    function debounce(fn, wait) {
      var timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
      };
    }

    function initPhotoCollage(grid) {
      if (grid.__collageInitialized) return;
      grid.__collageInitialized = true;

      layoutJustified(grid);
      window.addEventListener('resize', debounce(function () {
        layoutJustified(grid);
      }, 150));

      // Re-run once webfonts/late layout settle, in case container width shifted.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { layoutJustified(grid); });
      }

      // Catch container size changes that don't fire a `window` resize event —
      // e.g. the theme editor applying a new "images per row" value, or toggling
      // the editor's mobile preview (which resizes an iframe, not the window).
      if (typeof ResizeObserver !== 'undefined') {
        var skipFirst = true;
        var observer = new ResizeObserver(function () {
          // ResizeObserver always fires once immediately on observe(); skip it
          // since layoutJustified() already ran synchronously above.
          if (skipFirst) {
            skipFirst = false;
            return;
          }
          layoutJustified(grid);
        });
        observer.observe(grid);
      }
    }

    // ---- Lightbox ----
    function initLightbox(grid) {
      var lightbox = document.querySelector('[data-photo-lightbox]');
      if (!lightbox) return;

      var stageImage = lightbox.querySelector('[data-photo-lightbox-image]');
      var caption = lightbox.querySelector('[data-photo-lightbox-caption]');
      var downloadLink = lightbox.querySelector('[data-photo-lightbox-download]');
      var closeButtons = lightbox.querySelectorAll('[data-photo-lightbox-close]');
      var prevButton = lightbox.querySelector('[data-photo-lightbox-prev]');
      var nextButton = lightbox.querySelector('[data-photo-lightbox-next]');

      var triggers = Array.prototype.slice.call(
        grid.querySelectorAll('[data-photo-collage-trigger]')
      );
      var items = triggers.map(function (el) {
        return {
          full: el.getAttribute('data-full'),
          download: el.getAttribute('data-download'),
          downloadName: el.getAttribute('data-download-name') || 'photo.jpg',
          caption: el.getAttribute('data-caption') || ''
        };
      });

      var currentIndex = 0;
      var lastFocusedTrigger = null;

      function showIndex(index) {
        if (!items.length) return;
        currentIndex = (index + items.length) % items.length;
        var item = items[currentIndex];
        stageImage.src = item.full;
        stageImage.alt = item.caption;
        caption.textContent = item.caption;
        downloadLink.setAttribute('href', item.download);
        downloadLink.setAttribute('data-filename', item.downloadName);
      }

      function openLightbox(index, trigger) {
        lastFocusedTrigger = trigger || null;
        showIndex(index);
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        closeButtons[0] && closeButtons[0].focus();
      }

      function closeLightbox() {
        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
        stageImage.src = '';
        if (lastFocusedTrigger) {
          lastFocusedTrigger.focus();
        }
      }

      triggers.forEach(function (trigger, index) {
        trigger.addEventListener('click', function () {
          openLightbox(index, trigger);
        });
      });

      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', closeLightbox);
      });

      prevButton.addEventListener('click', function () {
        showIndex(currentIndex - 1);
      });

      nextButton.addEventListener('click', function () {
        showIndex(currentIndex + 1);
      });

      document.addEventListener('keydown', function (event) {
        if (lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') showIndex(currentIndex - 1);
        if (event.key === 'ArrowRight') showIndex(currentIndex + 1);
      });

      downloadLink.addEventListener('click', function (event) {
        var url = downloadLink.getAttribute('href');
        var filename = downloadLink.getAttribute('data-filename') || 'photo.jpg';
        if (!url) return;
        event.preventDefault();

        fetch(url, { mode: 'cors' })
          .then(function (response) {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.blob();
          })
          .then(function (blob) {
            var blobUrl = URL.createObjectURL(blob);
            var tempLink = document.createElement('a');
            tempLink.href = blobUrl;
            tempLink.download = filename;
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);
            setTimeout(function () {
              URL.revokeObjectURL(blobUrl);
            }, 1000);
          })
          .catch(function () {
            // Fallback: open the full-size image in a new tab so the visitor can save it manually.
            window.open(url, '_blank', 'noopener');
          });
      });
    }

    function initAll(root) {
      if (!root || !root.querySelectorAll) return;
      var grids = Array.prototype.slice.call(root.querySelectorAll('[data-photo-collage]'));
      if (root.matches && root.matches('[data-photo-collage]')) {
        grids.push(root);
      }
      grids.forEach(function (grid) {
        initPhotoCollage(grid);
        initLightbox(grid);
      });
    }

    initAll(document);

    // The Shopify theme editor re-renders this section's HTML (via the Section
    // Rendering API) whenever a setting changes — e.g. dragging the "images per
    // row" slider. That swaps in a brand-new grid element, so it needs its own
    // layout pass and its own ResizeObserver rather than relying on the old
    // (now-removed) grid's listeners.
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function playVideo(item) {
      var id = item.getAttribute('data-yt-id');
      var thumb = item.querySelector('[data-video-thumb]');
      if (!id || !thumb) return;
      thumb.style.backgroundImage = 'none';
      thumb.innerHTML =
        '<iframe src="https://www.youtube.com/embed/' +
        id +
        '?autoplay=1&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;border:0;"></iframe>';
    }

    document.querySelectorAll('[data-video-item]').forEach(function (item) {
      var thumb = item.querySelector('[data-video-thumb]');
      if (!thumb) return;
      thumb.addEventListener('click', function () {
        playVideo(item);
      });
      thumb.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          playVideo(item);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
